import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoFadeSplash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={457} height={395} fill='none' {...props}>
    <g
      fill='#fff'
      fillRule='evenodd'
      clipPath='url(#logo-fade-splash_svg__a)'
      clipRule='evenodd'
      opacity={0.05}
    >
      <path d='m133.28 72.71 70.63 179.25c74.7-27.48 124.08-99.39 123-179.25zM0 209.43v155.75c40.88 18.87 86.39 29.38 134.36 29.32 41 0 81.79-7.94 119.78-23.4-15.89-36.06-32.84-75.78-50.23-118.92C131.27 280.23 52.04 260.97 0 209.43M313 0c.42 1.05.83 2.1 1.24 3.16 8.37 22.11 12.88 45.72 12.88 69.34h129.87c-.09-24.94-3-49.2-8.42-72.5z' />
    </g>
    <defs>
      <clipPath id='logo-fade-splash_svg__a'>
        <path fill='#fff' d='M0 0h456.99v394.5H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoFadeSplash;
